import { IServiceData } from "../../bookingSlice.types";
import { ClientPortalPaymentModes, ServiceModel } from "types/generated/models";
import { BookingType } from "types/appointmentBooking";

export interface PaymentFlags {
    paymentEnabled: boolean;
    paymentRequired: boolean;
    paymentOptional: boolean;
}

export function getSelectedService(
    defaultGroupService: ServiceModel,
    reduxService: IServiceData,
    bookingType: BookingType
): IServiceData {
    if (!defaultGroupService && !reduxService) {
        return null;
    }

    if (bookingType === BookingType.CLIENT) {
        return reduxService;
    } else if (bookingType === BookingType.CLASS) {
        return {
            serviceId: defaultGroupService?.id,
            serviceName: defaultGroupService?.name,
            amount: defaultGroupService?.amount,
            portalDeposit: defaultGroupService?.portalDeposit,
            taxRate: defaultGroupService?.taxRate ?? undefined,
        };
    }
}

export function getPaymentFlags(
    bookingType: BookingType,
    appointmentsPaymentsMode: ClientPortalPaymentModes,
    groupPaymentsMode: ClientPortalPaymentModes,
    service: IServiceData,
    stripeConnected: boolean,
    discountedAmount?: number,
    paymentAlreadyReceived = false
): PaymentFlags {
    const effectiveAmount = discountedAmount ?? service?.amount;
    // A restored class seat keeps the invoice the client already paid, so nothing is owed.
    if (paymentAlreadyReceived || stripeConnected === false || !service || effectiveAmount === 0) {
        return {
            paymentEnabled: false,
            paymentRequired: false,
            paymentOptional: false,
        };
    }
    const needsDeposit = service?.portalDeposit > 0;

    switch (bookingType) {
        case BookingType.CLIENT:
            return {
                paymentEnabled: !!appointmentsPaymentsMode || needsDeposit,
                paymentRequired: appointmentsPaymentsMode === ClientPortalPaymentModes.Required,
                paymentOptional: appointmentsPaymentsMode === ClientPortalPaymentModes.Optional,
            };
        case BookingType.CLASS:
            return {
                paymentEnabled: !!groupPaymentsMode || needsDeposit,
                paymentRequired: groupPaymentsMode === ClientPortalPaymentModes.Required,
                paymentOptional: groupPaymentsMode === ClientPortalPaymentModes.Optional,
            };
        default:
            return {
                paymentEnabled: false,
                paymentRequired: false,
                paymentOptional: false,
            };
    }
}
